<template>
	<div ref="card"></div>
</template>

<script>
/* eslint-disable new-cap */
let stripe,
	elements,// = stripe.elements(),
	card = undefined,
	resultWas,
	parentWas,
	vm;

import { mapGetters } from 'vuex';
import ENV_VARS from '@/modules/env-vars.js';

export default {
	name: 'StripeCard',
	props: ['resetStripe', 'parent'],
	created(){
		stripe = window.Stripe(ENV_VARS.STRIPE_TOKEN);
		elements = stripe.elements();
	},
	methods: {
		destroyCard() {
			card.destroy();
			card = null;
		},
		addCard() {
			card = elements.create('card');
			card.mount(this.$refs.card);

			card.focus();

			card.addEventListener('change', function(event) {
				if (event.complete) {
					stripe.createToken(card).then(function(result) {
						vm.$emit('create-token', result);
					});
				} else if (resultWas !== event.complete) {
					vm.$emit('create-token', null);
				}

				resultWas = event.complete;
			});
			parentWas = this.parent;
		}
	},
	watch: {
		resetStripe: function (newValue, oldValue) {
			vm = this;
			const newCardMounting = (this.parent !== parentWas && newValue) || !card;
			// card needs to be mounted
			if (newCardMounting) {
				if (card) {
					this.destroyCard();
				}
				this.addCard();
				return;
			}
			// just clear the existing card
			if (!newValue) {
				card.clear();
			}
		}
	},
	destroyed: function() {
		if (card) {
			this.destroyCard();
		}
	}
};
</script>



// WEBPACK FOOTER //
// ./src/components/StripeCard.vue